import { queryApi } from '../../../api'
import { ENDPOINT } from '../../../constants'
import { IDeltakerMutateVars } from '../types'

export const deltakerApi = {
  post: async ({ type, deltaker, kvitteringId }: IDeltakerMutateVars) => {
    return queryApi.post(
      `${ENDPOINT.TILSYNSKVITTERING}/tilsynskvitteringer/${kvitteringId}/${type}`,
      {
        navn: deltaker.navn,
      }
    )
  },
  put: async ({ type, deltaker }: IDeltakerMutateVars) => {
    const url = `${ENDPOINT.TILSYNSKVITTERING}/${type}/${deltaker.id}`

    return queryApi.put(url, {
      ...deltaker,
      id: null,
      _links: {
        self: {
          href: url,
        },
      },
    })
  },
  delete: async ({ type, deltaker }: IDeltakerMutateVars) => {
    return queryApi.delete(
      `${ENDPOINT.TILSYNSKVITTERING}/${type}/${deltaker.id}`
    )
  },
}
